import WarnController from './warn-modal.controller';
import template from './warn-modal.html';

class AppController {

    constructor($scope, $state, $uibModal) {

        this._$uibModal = $uibModal;

        let countTabs = localStorage.getItem('openpages') || 0 ;

        if(localStorage.getItem('openpages') > 0) {
            // this.openHelpWindow();
            // localStorage.setItem('openpages', ++countTabs);
        } else {
            // localStorage.setItem('openpages', ++countTabs);
        }

        window.onbeforeunload = function () {
          countTabs = localStorage.getItem('openpages') || 0;
          if(countTabs > 0) {
            // localStorage.setItem('openpages', --countTabs);
          }
        };
    }

    openHelpWindow() {
      this._$uibModal.open({
        animation: false,
        template: template,
        controllerAs: '$ctrl',
        size: 'sm',
        resolve: {
          type: () => {
            return this.topic;
          }
        },
        controller: WarnController,
      });
    }
};

AppController.$inject = ['$scope',  '$state', '$uibModal'];

export default AppController;



// WEBPACK FOOTER //
// ./client/app/app.controller.js